
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 700 700"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M537.7 341.3l-151 113.8-49-56.8c-2.2-2.7-5.5-4.4-9-4.7-3.5-.3-7 .8-9.7 3.1-2.7 2.3-4.3 5.6-4.5 9.1-.2 3.5 1 7 3.3 9.6l57 66.1c4.5 5.2 12.3 6.1 17.8 1.9l160.8-121.2c5.8-4.4 7-12.6 2.6-18.4-4.3-5.7-12.5-6.9-18.3-2.5z"}}),_c('path',{attrs:{"d":"M572.9 203.4H300.6c-13.4 0-26.2 5.3-35.6 14.8-9.4 9.4-14.8 22.2-14.8 35.6v317.1c0 13.3 5.3 26.1 14.8 35.6 9.4 9.4 22.2 14.8 35.6 14.8h272.3c13.4 0 26.2-5.3 35.6-14.8 9.4-9.4 14.8-22.2 14.8-35.6V253.8c0-13.4-5.3-26.2-14.8-35.6-9.5-9.4-22.3-14.7-35.6-14.8zM597 570.9c0 6.4-2.6 12.5-7.1 17s-10.6 7-17 7.1H300.6c-6.4 0-12.5-2.6-17-7.1s-7.1-10.6-7.1-17V253.8c0-6.4 2.5-12.5 7.1-17 4.5-4.5 10.6-7.1 17-7.1h272.3c6.4 0 12.5 2.6 17 7.1s7.1 10.7 7.1 17v317.1z"}}),_c('path',{attrs:{"d":"M103 446.2v-317c0-6.4 2.6-12.5 7.1-17.1 4.5-4.5 10.7-7.1 17.1-7.1h272.3c6.4 0 12.5 2.6 17.1 7.1 4.5 4.5 7.1 10.7 7.1 17.1v52.4h26.2v-52.4c0-13.4-5.3-26.2-14.8-35.6-9.4-9.4-22.3-14.8-35.6-14.8H127.1c-13.4 0-26.2 5.3-35.6 14.8-9.4 9.4-14.8 22.3-14.8 35.6v317c0 13.4 5.3 26.2 14.8 35.6 9.4 9.4 22.3 14.8 35.6 14.8h101.2v-26.2H127.1c-6.4 0-12.5-2.6-17.1-7.1-4.4-4.6-7-10.7-7-17.1z"}})])
          )
        }
      }
    